// Module
var code = "<div> <div class=\"groupDetailsDropdown\"> <span class=\"selectLink\"><!-- ko text: _labels.SELECT_LABEL --><!-- /ko --></span> </div> <div> <!-- ko with: _grid --> <!-- ko template: {name: GetTemplateName, afterRender: $data.AfterRender.bind($data)} --> <!-- /ko --> <!-- /ko --> </div> </div>";
// Exports
export default code;